// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Q0n0","footer":"styles_footer__3Jn-p","passCodeTooltip":"styles_passCodeTooltip__MYmAx"};